import { Link } from "react-router-dom";
import { RotateCcw, Ban, ShieldCheck, Factory } from "lucide-react";

export function ReturnBadge({ p }) {
  const d = p.return_days ?? 7;
  const warranty = p.info?.Warranty;
  return (
    <div className="grid sm:grid-cols-2 gap-2 text-xs" data-testid="product-policy-badges">
      <Link to="/policies/returns" data-testid="product-return-policy" className="flex items-center gap-2 rounded-xl bg-white/5 px-3 py-2.5 hover:bg-white/10">
        {d ? <RotateCcw size={14} className="text-emerald-400" /> : <Ban size={14} className="text-amber-400" />}
        {d ? `${d}-day easy return` : "Non-returnable (replacement if damaged)"}
      </Link>
      {warranty && <div data-testid="product-warranty" className="flex items-center gap-2 rounded-xl bg-white/5 px-3 py-2.5"><ShieldCheck size={14} className="text-[#00f0ff]" />{warranty}</div>}
    </div>
  );
}

export default function ProductInfo({ p }) {
  const rows = Object.entries(p.info || {});
  if (!rows.length) return null;
  return (
    <div className="space-y-3" data-testid="product-info">
      <p className="font-display font-bold flex items-center gap-2"><Factory size={16} className="text-[#ff5500]" />Product information</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {rows.map(([k, v]) => (
          <div key={k} data-testid={`product-info-${k.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="flex justify-between gap-4 rounded-xl bg-white/5 px-4 py-3 text-sm">
            <span className="text-slate-500 shrink-0">{k}</span><span className="text-right">{v}</span>
          </div>
        ))}
      </div>
      <p className="text-xs text-slate-500">Read our <Link to="/policies/returns" className="text-[#ff5500] hover:underline">Return</Link>, <Link to="/policies/refund" className="text-[#ff5500] hover:underline">Refund</Link> and <Link to="/policies/cancellation" className="text-[#ff5500] hover:underline">Cancellation</Link> policies.</p>
    </div>
  );
}

export function SizePicker({ sizes, value, onChange, error, label = "Select size" }) {
  if (!sizes?.length) return null;
  return (
    <div className="space-y-2" data-testid="size-picker">
      <p className="text-sm font-semibold">{label} {value && <span className="text-slate-400 font-normal">· {value}</span>}</p>
      <div className="flex flex-wrap gap-2">
        {sizes.map((s) => (
          <button key={s} type="button" data-testid={`size-option-${s}`} onClick={() => onChange(s)}
            className={`min-w-12 h-11 px-3 rounded-xl border text-sm font-semibold transition-colors ${value === s ? "bg-white text-black border-white" : "border-white/15 hover:border-white/50"}`}>{s}</button>
        ))}
      </div>
      {error && <p data-testid="size-error" className="text-xs text-red-400">Please {label.toLowerCase()}</p>}
    </div>
  );
}
